"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStablecoinPayment = exports.effectivePaymentMethod = exports.DealingPaymentMethod = void 0;
/** How an investor pays for a subscription or is paid for a redemption: AUD bank transfer or AUDM stablecoin. */
exports.DealingPaymentMethod = {
    bank: "bank",
    stablecoin: "stablecoin",
};
/** Records lodged before stablecoin dealing carry no payment method, and they are all bank transfers. */
const effectivePaymentMethod = (record) => record.paymentMethod ?? exports.DealingPaymentMethod.bank;
exports.effectivePaymentMethod = effectivePaymentMethod;
/** Whether a request is paid or paid out through a vault in stablecoin; anything else is a bank transfer. */
const isStablecoinPayment = (paymentMethod) => paymentMethod === exports.DealingPaymentMethod.stablecoin;
exports.isStablecoinPayment = isStablecoinPayment;
//# sourceMappingURL=dealingPaymentMethod.js.map